module.exports = __webpack_public_path__ + "static/img/industriesbg2.359a248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriesbg2.jpg
// module id = YLvo
// module chunks = 1